import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { XCircle, RotateCcw } from "lucide-react";

export default function PaymentFailed() {
  const { registrationId } = useParams();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const reason = params.get("reason") || "Something went wrong during payment";

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6">
      <div
        className="w-full max-w-md bg-white border border-zinc-200 rounded-md overflow-hidden"
        data-testid="payment-failed-card"
      >
        <div className="p-8 border-b border-zinc-200 flex flex-col items-center text-center">
          <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <XCircle className="w-8 h-8 text-red-600" />
          </div>
          <p className="overline text-red-600 mb-2">Payment failed</p>
          <h1 className="font-heading text-2xl font-semibold tracking-tight mb-2">
            Payment failed. Please try again.
          </h1>
          <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">
            {reason}
          </p>
        </div>

        <div className="p-6 space-y-3">
          <Button
            onClick={() => nav(`/pay/${registrationId}`)}
            className="w-full h-11 bg-black text-white hover:bg-zinc-800 rounded-md"
            data-testid="retry-payment-button"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            Retry payment
          </Button>
          <p className="text-xs text-zinc-400 text-center">
            Your registration is held for this event while you complete payment.
            You can safely retry.
          </p>
        </div>
      </div>
    </div>
  );
}
